import { render } from "./Product2View.vue?vue&type=template&id=23c8b971"
import script from "./Product2View.vue?vue&type=script&lang=js"
export * from "./Product2View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__